import { Flex } from "@ecco/ui/flex";
import { Text } from "@ecco/ui/text";
import { styles } from "../errors/error.styles";

import type { JSX } from "react";

interface Props {
    message: string;
}

export const ErrorMessage = ({ message }: Props): JSX.Element => {
    return (
        <Flex
            sx={styles.sectionErrorContainer}
            gap={5}
            mt={4}
            direction={{ base: "column-reverse", md: "row" }}
            role="alert"
        >
            <Text>{message}</Text>
        </Flex>
    );
};

export default ErrorMessage;
